<div class="{{styles.flag}}">{{each props.info info key}}<oy-checkbox data-key="{{key}}"></oy-checkbox>{{/each}}</div>


// WEBPACK FOOTER //
// ./D:/project/issts/oy-search-component/src/components/OYFilter/components/OYFlag/index.art